import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';

/** Repli identique aux dates "non renseignées" déjà utilisé à travers le site public. */
const DEFAULT_OPTIONS: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };

/**
 * Formate une date via Intl.DateTimeFormat dans la locale de la langue active (voir
 * LanguageService#localeCode), pour remplacer les usages de `toLocaleDateString('fr-FR', …)`
 * codés en dur qui ne réagissaient pas au changement de langue.
 *
 * Volontairement impur (`pure: false`) : la valeur passée au pipe (la date) ne change pas quand
 * l'utilisateur bascule de langue, seul `LanguageService.localeCode` change — un pipe pur ne serait
 * jamais réévalué dans ce cas.
 */
@Pipe({ name: 'localizedDate', pure: false })
export class LocalizedDatePipe implements PipeTransform {
  private readonly language = inject(LanguageService);

  transform(value: string | Date | null | undefined, options: Intl.DateTimeFormatOptions = DEFAULT_OPTIONS): string {
    if (!value) return '';
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(this.language.localeCode(), options).format(date);
  }
}
